module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.enableCompare) ? _c('div', {
    ref: "singleChartRef",
    staticStyle: {
      "height": "400px",
      "width": "100%"
    }
  }) : _c('div', {
    ref: "compareChartRef",
    staticStyle: {
      "height": "400px",
      "width": "100%"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-890ead80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dataSheet/utils/TrendChart.vue
// module id = 1027
// module chunks = 3